"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _moment = _interopRequireDefault(require("moment"));

var _listSecteurGeoMultiple = _interopRequireDefault(require("@/components/listSecteurGeoMultiple"));

var _StickyTable = _interopRequireDefault(require("@/components/StickyTable.vue"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination.vue"));

var _ScrollBar = _interopRequireDefault(require("@/components/ScrollBar.vue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'SageList',
  components: {
    StickyTable: _StickyTable.default,
    Pagination: _Pagination.default,
    ScrollBar: _ScrollBar.default,
    listSecteurGeoMultiple: _listSecteurGeoMultiple.default
  },
  data: function data() {
    return {
      dataTable: [],
      currentPage: 1,
      pageSize: 100,
      show: false,
      activeFilter: '',
      columns: {
        // affaire
        'affaire.code_analytique': {
          key: 0,
          prop: 'affaire_code_analytique',
          label: 'Code analytique',
          width: 200
        },
        'affaire.secteur_act_code': {
          key: 1,
          prop: 'secteur_act_code',
          label: 'Code act.',
          width: 70
        },
        'affaire.secteur_geo_code': {
          key: 2,
          prop: 'secteur_geo_code',
          label: 'Code ets.',
          width: 150
        },
        'affaire.secteur_geo_libelle': {
          key: 3,
          prop: 'secteur_geo_libelle',
          label: 'Code ets.',
          width: 150
        },
        'affaire.compte_auxiliaire': {
          key: 4,
          prop: 'affaire_compte_auxiliaire',
          label: 'Compte tiers',
          width: 200
        },
        // tva
        'tva.compte_general': {
          key: 5,
          prop: 'tva_compte_general',
          label: 'Compte TVA',
          width: 90
        },
        'tva.taux': {
          key: 6,
          prop: 'tva_taux',
          label: 'Taux TVA',
          width: 50
        },
        // type de vente
        'type_vente.code': {
          key: 7,
          prop: 'type_vente_code',
          label: 'Type de vente',
          width: 70
        },
        // facture
        'facture.date_facture': {
          key: 8,
          prop: 'facture_date_facture',
          label: 'Date',
          width: 110
        },
        'facture.date_echeance': {
          key: 9,
          prop: 'facture_date_echeance',
          label: 'Échéance',
          width: 110
        },
        'facture.libelle': {
          key: 10,
          prop: 'facture_libelle',
          label: 'Libellé',
          width: 300
        },
        'facture.montant_ht': {
          key: 11,
          prop: 'facture_montant_ht',
          label: 'HT facturé',
          width: 120
        },
        'facture.montant_tva': {
          key: 12,
          prop: 'facture_montant_tva',
          label: 'TVA facturé',
          width: 120
        },
        'facture.mt_avant_paiement_direct_ttc': {
          key: 13,
          prop: 'facture_mt_avant_paiement_direct_ttc',
          label: 'TTC avant P.D.',
          width: 120
        },
        'facture.mt_paiement_direct_st': {
          key: 14,
          prop: 'facture_mt_paiement_direct_st',
          label: 'P.D.',
          width: 120
        },
        'facture.numero': {
          key: 15,
          prop: 'facture_numero',
          label: 'Numéro',
          width: 110
        },
        'facture.retenue_garantie': {
          key: 16,
          prop: 'facture_retenue_garantie',
          label: 'R.G.',
          width: 120
        }
      },
      csvSageData: [],
      csvSageLabels: {
        facture_date_facture: 'Date facture',
        facture_date_echeance: 'Date echeance',
        type_vente_code: 'Type de vente',
        facture_numero: 'Num facture',
        facture_libelle: 'Libelle facture',
        affaire_code_analytique: 'Num affaire (code analytique)',
        // Etablissement: Code secteur géographique
        secteur_geo_code: 'Etablissement',
        // Compte tiers: compte auxiliaire de l'affaire
        affaire_compte_auxiliaire: 'Compte tiers',
        tva_compte_general: 'Compte TVA',
        tva_taux: 'Taux TVA',
        facture_montant_ht: 'Montant HT',
        facture_montant_tva: 'Montant TVA',
        facture_retenue_garantie: 'RG',
        facture_mt_avant_paiement_direct_ttc: 'Montant TTC avant paiement direct',
        secteur_act_code: 'Code secteur Activites'
      },
      dialogDetailVisible: false,
      filters: [// Filtre #0 : filtre sur secteur géographique
      {
        value: [],
        prop: ['secteur_geo_id'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'secteur_geo_id':
                if (filter.value.length === 0) {
                  return true;
                }

                return filter.value.includes(row.affaire.secteur_geo.id);

              default:
                return false;
            }
          });
        }
      }, // Filtre #1 : si la date de facture est >= date de début de période
      {
        value: '',
        prop: ['facture_date_facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_facture;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #2 : si la date de facture est <= date de fin de période
      {
        value: '',
        prop: ['facture_date_facture'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_facture':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_facture;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #3 : si le montant du P.D. de la facture est >= montant saisie
      {
        value: '',
        prop: ['facture_mt_paiement_direct_st'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_paiement_direct_st':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_paiement_direct_st;
                return montant >= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #4 : si le montant du P.D. de la facture est <= montant saisie
      {
        value: '',
        prop: ['facture_mt_paiement_direct_st'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_mt_paiement_direct_st':
                if (filter.value === null) {
                  return true;
                }

                var montant = row.facture.mt_paiement_direct_st;
                return montant <= Number.parseFloat(filter.value).toFixed(2);

              default:
                return false;
            }
          });
        }
      }, // Filtre #5 : si la date d'échéance est >= date de début de période
      {
        value: '',
        prop: ['facture_date_echeance'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_echeance':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_echeance;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrAfter(filter.value);

              default:
                return false;
            }
          });
        }
      }, // Filtre #2 : si la date d'échéance est <= date de fin de période
      {
        value: '',
        prop: ['facture_date_echeance'],
        filterFn: function filterFn(row, filter) {
          return Object.keys(row).some(function (prop) {
            switch (prop) {
              case 'facture_date_echeance':
                if (filter.value === null) {
                  return true;
                }

                var date = row.facture.date_echeance;

                if (!date || typeof date === 'undefined') {
                  return false;
                }

                return (0, _moment.default)(String(date), 'YYYY-MM-DD').isSameOrBefore(filter.value);

              default:
                return false;
            }
          });
        }
      }],
      multipleSelection: [],
      row: [],
      rowComment: {},
      rowSpan: {
        label: 4,
        selection: 1,
        field: 5
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler(newValue) {
        this.getData();
      }
    },
    // Changement de sélection du filtre sur les clients
    'filters.1.value': function filters1Value(newVal, oldVal) {
      // Si on déselectionne le client
      if (newVal === null) {
        // On vide aussi la liste des enseignes liées
        this.filters[2].value = null;
      } // console.log('idClient has changed', newVal, oldVal)

    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {}, (0, _vuex.mapGetters)('facturation', ['getSyntheseList']), {
    csvSageColumns: function csvSageColumns() {
      return Object.keys(this.csvSageLabels);
    },
    dateFormat: function dateFormat() {
      return this.user.date_format; // dd/MM/yyyy
    },
    filterExists: function filterExists() {
      var filterExists = false;
      this.filters.forEach(function (x, index) {
        // console.log(index + '# typeof', x.value, typeof x.value)
        switch (_typeof(x.value)) {
          case 'string':
            if (x.value !== null && x.value !== '') {
              filterExists = true;
            }

            break;

          case 'number':
            if (x.value !== null && x.value > 0) {
              filterExists = true;
            }

            break;

          case 'object':
            if (x.value && x.value.length > 0) {
              filterExists = true;
            }

            break;
        }
      });
      return filterExists;
    },
    pageIdent: function pageIdent() {
      return "".concat(this.user.id_societe, "-VenteCreance-SageLigne1000");
    },
    total: function total() {
      return this.dataTable.length;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      var savedFilters, filters;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Récupération des filtres sauvegardés
              savedFilters = localStorage.getItem("Filters_".concat(this.pageIdent));

              if (savedFilters) {
                filters = JSON.parse(savedFilters);
                filters.forEach(function (row, index) {
                  _this.filters[index].value = row;
                });
              }

              _context.next = 4;
              return this.loadSyntheseList();

            case 4:
              _context.next = 6;
              return this.getData();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  methods: _objectSpread({}, (0, _vuex.mapActions)('facturation', ['loadSyntheseList']), {
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var filters;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$loader(true);
                this.show = false; // Sauvegarde des filtres dans le localStorage

                filters = this.filters.map(function (filter) {
                  return filter.value;
                });
                localStorage.setItem("Filters_".concat(this.pageIdent), JSON.stringify(filters)); // Filtrage des données en fonction des filtres

                _context2.next = 6;
                return this.applyFilters();

              case 6:
                this.$loader(false);
                this.show = true;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    applyFilters: function applyFilters() {
      var _this2 = this;

      var data = this.getSyntheseList;
      var filteredData = data.filter(function (row) {
        return _this2.filters.every(function (filter) {
          if (!filter.value || filter.value === '') {
            // Si la valeur du filtre est vide, passer au suivant
            return true;
          } // Appliquer la fonction de filtre


          return filter.filterFn(row, filter);
        });
      });
      this.dataTable = filteredData;
    },
    initPreparedDataForExport: function initPreparedDataForExport() {
      // On utilise les données pré-filtrées par le dataTable
      this.csvSageData = this.$refs.dataTable.tableData;
    },
    showNbReglement: function showNbReglement(reglements) {
      return "".concat(reglements.length, " r\xE8glement").concat(reglements.length > 1 ? 's' : '');
    }
  })
};
exports.default = _default;